/* 🤖 this file was generated by svg-to-ts */
export const matIconDownloadDone: {
  name: 'download-done';
  data: string;
} = {
  name: 'download-done',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M5 18h14v2H5v-2zm4.6-2.7L5 10.7l2-1.9 2.6 2.6L17 4l2 2-9.4 9.3z"/></svg>`
};
